module.exports = __webpack_public_path__ + "img/warning.f885bef7.png";